module.exports = __webpack_public_path__ + "img/brands-mulino-vorrei.jpg?6206f6b80415a6cb865bfa596737a197";